export const UPDATE_NEWS_DATA:string = 'news/UPDATE_NEWS_DATA';